exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-header-title hr.line {\n    display: block;\n    height: 3px;\n    border: 0;\n    color: inherit;\n    margin: 10px 0 0 5px;\n    padding: 0;\n    width: 80px;\n}\n\n.chart-header-title{\n  float: left;\n  width: auto;\n  display: inline-flex;\n  text-align: center;\n  padding: 0 20px 0 0;\n  margin-bottom: 20px;\n}\n\n.chart-header-titles{\n  width: 100%;\n  padding: 0 10px 0 20px;\n}\n", ""]);

// exports
